let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7UMfo")).then(() => parcelRequire('5mo7T'));